<p-dialog [(visible)]="visible" [style]="{width: widthSize}" [maximizable]="true" [closable]="!disabled"
    (onHide)="cancel()">
    <app-grid #grid [columnDefs]="columsDef" [rowData]="rowData" [rowSelection]="'multiple'" [isMasterDetail]="false"
        [isProjectOwnershipValid]="isProjectOwnershipValid" [suppressRowClickSelection]="true" [pagination]="true"
        [paginationPageSize]="5" [useDeleteAction]="true" [useAddAction]="true" addLabel="Add" [rowHeight]="rowHeight"
        (addEvent)="newRowAdded($event)" (dropDownSelectionChangeEvent)="onSelectionChanged($event)"
        (sprayDriftOptionSelectionChangedEvent)="onSelectionChanged($event)"
        (enableControlsEmit)="enableControls($event)"></app-grid>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="save()" label="Save"
            [disabled]="!isProjectOwnershipValid || disabled" pAutoFocus [autofocus]="true"></p-button>
    </ng-template>
</p-dialog>